<template>
    <div @click="closeDesktopSideBar()" v-if="!mobile" class="navigation-bar d-md-flex flex-row">
        <profile :profileModal="profileModal"
        :walletId="connectedAccount"
        @disconnect='disconnect'
        @profileModal="closeProfileModal"></profile>
        <div class="logo d-flex">
            <nav @click="desktopSideBar == false ? openDesktopSideBar() : ''">
                <img class="desktop-hamburger" width="42px" height="41px" src="../assets/images/desktop-hamburger.webp" alt="">
            </nav>   
            <router-link :to="{name: 'farm'}">
                <img src="../assets/images/logo-component-1.webp" alt="">
            </router-link>
        </div>
        <div class="router-links d-flex justify-content-between w-50 align-items-center h-100">
            <router-link :to="{name: 'farm', props:{isMobile: true}}" exact>Farm</router-link>
            <router-link :to="{name: 'games'}">Games</router-link>
            <router-link  :to="{name: 'minting'}">Minting</router-link>
          <!--  <router-link :to="{name: 'whitepaper'}">WhitePaper</router-link>
                <router-link :to="{name: 'gamedata'}">Game&nbsp;Data</router-link> -->
        </div>
        <div class="outsider-directions d-flex align-items-center justify-content-end" style="margin:0 37px">
            <div class="eggs-token-quantity" style="margin-right:15px">
                <img src="../assets/images/eggtoken-2.webp" alt="">
                {{showEggBalance}}
            </div>
             <button v-if="connected" @click="profileModal = true">
                <span>{{connectedAccount.slice(0,4)}}...{{connectedAccount.slice(connectedAccount.length - 4,connectedAccount.length)}} </span>
            </button>
            <button v-else @click="connect">
                connect wallet
            </button>
        </div>
    </div>
    <div v-else class="hamburger-menu d-flex flex-row">
            <nav @click="openSidebar()" class="menu-icon hamburger-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#ffe371" class="bi bi-list " viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                </svg>
            </nav>
            <div class="logo-mobile" @click="routeToFarm()">
                <img src="../assets/images/logo-component-1.webp" alt="">
            </div>
            <div><span></span></div>
    </div>

</template>
<script>

import Profile from './Profile.vue'
export default {
    components: { Profile },
    name: 'topbar',
    props: {
        mobile: {
            default: false,
            type: Boolean
        },
        connectedAccount: {
            default: null,
            type: String
        },
        connected:{
            default: false,
            type: Boolean
        },
        eggsBalance:{
            default: "",
            type: String
        },
        desktopSideBar:{
            default: false,
            type: Boolean
        },
    },
    data(){
        return{
            sideBar:false,
            profileModal:false,
            desktopSideBarInsıde:this.desktopSideBar
        }
    },
    computed:{
        showEggBalance(){
            return parseFloat(this.eggsBalance).toFixed(2)
        }
    },
    methods: {
        openDesktopSideBar(){
            setTimeout(() => {
                this.desktopSideBarInsıde= true
                this.$emit('openDesktopSidebar' , this.desktopSideBarInsıde)
            }, 1);
        },
        closeDesktopSideBar(){
            if(this.desktopSideBar){
                this.desktopSideBarInsıde= false
                this.$emit('openDesktopSidebar' , this.desktopSideBarInsıde)
            }
        },
        connect(){
            this.$emit('connect')
        },
        openSidebar(){
            this.sideBar= true
            this.$emit('openSidebar' , this.sideBar)   
        },
        closeProfileModal(value){
            this.profileModal = value
        },
        disconnect(){
            this.$emit('disconnect' , true)
        },
        routeToFarm(){
            this.$router.push({name:'farm'})
        }
    }
}
</script>
<style scoped>
.navigation-bar{
    background-color: #0a0f1e;
    box-shadow: -2.6px 1.5px 2px 0 #ffe374;
    position:fixed;      
    left:0;
    top:0;
    z-index:200;
    width: 100%;
    flex-wrap: nowrap;
    height: 85px;
}
.desktop-hamburger{
    margin: 11px 20px 18px 0;
    cursor: pointer;
}
.desktop-sidebar{
    margin-top: 90px;
    position: fixed;
    height: calc(100% - 90px) ;
    width: 268px;
    background: rgba(10, 15, 30, 0.5)
}
.logo{
    margin: 11px 20px 18px 22px;
}
.router-links{
    height: 85px;
}
.router-links a {
    height: 85px;
    line-height: 85px;
    font-size: 37px;
    margin-left: 63px;
    text-align: center;
}
.hamburger-menu{
    width: 100%;
    justify-content: space-between;
}
.hamburger-button{
    margin: 10px;
    padding: 5px;
    border: 3px solid #3E3F33;
    border-radius: 5px;
}
.logo-mobile{
    margin-left: -40px;
}
.menu{
    left: 0;
    top: 0;
    z-index: 5;
    padding: 33px;
    width: calc(100% - 100px);
    height: 500px;
    background-color: #040B13;
}
.outsider-directions{
    width: 100%;
}
.outsider-directions a img{
    float: right;
    margin: 22px 29px 18px 0;
}
.outsider-directions button{
    float: right;
    background: none;
    border: 2px solid white;
    padding: 8px 15px 7px 15px;
    border-radius: 18px;
    line-height: 25px;
    font-size: 29.5px;
    color: white;
}
.eggs-token-quantity{
    float: right;
    background: none;
    border: 2px solid #ffcc20;;
    padding: 8px 15px 7px 15px;
    border-radius: 18px;
    line-height: 25px;
    margin-top: 3px;
    font-size: 29.5px;
    color: #ffcc20;
    min-width: 150px;
    text-align: center;
}
.router-links a.router-link-active {
  color: #ffe371;
  text-decoration: none;
}

@media (max-width: 1300px) {
    .router-links a{
        margin-left: 20px;
        font-size: 30px
    }
}
@media (max-width: 1100px) {
    .router-links a{
        font-size: 17px;
        margin-left:10px
    }
}
</style>